import React from 'react'
import api from '../services/api'
import {ILicenseProducts} from '../types/types'
const useLicenseProducts = () => {
const [products, setProducts] = React.useState<ILicenseProducts[]>([])
  const [loading, setLoading] = React.useState(false)
  const [error, setError] = React.useState(null)


  //params = isActive, isPurchasable, parentId

    const fetchProducts = async (params = {}) => {
        setLoading(true)
        setError(null)
        try {
            const response = await api.get('/licenses-products', {params})  
            console.log(response.data);
            if (response?.data?.licenseProducts) {
                setProducts(response.data.licenseProducts)
            } else {
                setProducts([])
                setError('No products found')
            }
        } catch (err) {
            console.log(err);
            setError('Error fetching products')
            setProducts([])
            console.error('Error fetching products:', err)
        } finally {
            setLoading(false)
        }
    }


    const fetchPurchasableProducts = async (licenseId: number) => {
        //licenses-products/licenses/fetch-purchasable-products/1210

        setLoading(true)
        setError(null)
        try {
            const response = await api.get(`/licenses-products/licenses/fetch-purchasable-products/${licenseId}`)  
            console.log(response.data);
            if (response?.data?.products) {
                setProducts(response.data.products)
            } else {
                setProducts([])
                setError('No products found')
            }
        } catch (err) {
            console.log(err);
            setError('Error fetching products')
            setProducts([])
            console.error('Error fetching products:', err)
        } finally {
            setLoading(false)
        }



    }

    const reset = () => {
        setProducts([])
        setLoading(false)
        setError(null)
    }

    return {reset,products, loading, error, fetchProducts,fetchPurchasableProducts}

}

export default useLicenseProducts